export default __webpack_public_path__ + "static/media/commentImg.930869d1.png";